import clsx from 'clsx';
import type React from 'react';

import type * as hiveCore from '@gitbook/hive-core';
import { Icon } from '@gitbook/spine-icons';
import { renderIcon } from '@gitbook/spine-react';

import { truncate } from '../../utils/text';
import { PageIcon } from '../Page/PageIcon';

export function CommentContextLink(props: {
    page: hiveCore.RevisionPageDocument | null;
    prefix?: string;
    className?: string;
}): React.ReactElement {
    const { page, prefix = '', className } = props;

    const pageIcon = renderIcon(
        page ? (
            <PageIcon page={page} size={14} className="m-nudge-icon" />
        ) : (
            <Icon.Trashcan size={12} className="m-nudge-icon" />
        )
    );

    return (
        <span className={clsx('flex items-center gap-1 text-base text-ui-small', className)}>
            {prefix}
            <span className={clsx('flex items-center gap-1', page ? 'text-base' : 'text-danger')}>
                {pageIcon}
                {page ? truncate(page.title, 18) : 'Deleted page'}
            </span>
        </span>
    );
}
